import type { FeatureFlagsBase } from '../types'
import { useRuntimeConfig } from '#imports'

/**
 * Jurisdictions pass their own flag type, e.g. `useFeatureFlags<FeatureFlags>()`, since core can't resolve `#types`.
 */
export const useFeatureFlags = <Flags extends FeatureFlagsBase = FeatureFlagsBase>() => {
    const { public: { flags } } = useRuntimeConfig()

    // Runtime config holds the serialized shape; double cast back to the options type.
    return flags as unknown as Flags
}
